export const DATETIMEFORMATTYPE = 'YYYY-MM-DD HH:mm'
